<template lang="pug">
  div 
    h4(v-text="`Viagens pendentes de sincronização`" class="mb-2 ml-2")
    v-data-table(
      :headers="table.notSincronized.headers"
      :items="table.notSincronized.viagens.itens"
      :server-items-length="table.notSincronized.viagens.total"
      :hide-default-footer="true"
      :footer-props="{ showFirstLastPage: false, showCurrentPage: false }"
      class="pa-3 mb-2 "
  
    )
      template(v-slot:item.id="{item}")
        span(v-text="item.sentido === 'VOLTA' ? item.viagemOrigemId : item.id")
      template(v-slot:item.dataInicio="{item}")
        span(v-text="item.status == 'FINALIZADA' ? dateFormat(item.dataFim) : dateFormat(item.dataInicio)")
  
      template(v-slot:item.action="{item}")
        v-btn(icon )
          v-icon(v-text="'autorenew'" @click="send(item)")
        //- v-btn( icon :disabled="item.status == 'INICIADA' ? false : true")
        //-   v-icon(v-text="`check_circle`" @click="finishTravelIndexDB(item.idCache)")
        v-btn( icon )
          v-icon(v-text="`delete`" @click="activeDialog(item.idCache)")
          
    v-dialog(
      v-model="dialog"
      persistent
      max-width="315"
    )
      v-card
        v-card-title(class="d-flex flex-column justify-center title-card")
          //- v-icon(v-text="'question_mark'" class="questionIcon")
          v-icon(v-text="'report'" x-large class="mt-1" color="red")
          p(class="text-h6 mt-2 " v-text="`Excluir viagem`")
          p(class="text-subtitle-2 text-justify" v-text="' Essa viagem não será enviada para ARCE e DETRAN-CE, deseja continuar ?'")
            
        v-card-actions(class="d-flex justify-space-between")
          v-btn(
            color="primary darken-1"
            text
            @click="deleteViagemById()"
            v-text="'Sim'"
          )
          v-btn(
            color="primary darken-1"
            text
            @click="dialog = false"
            v-text="'Não'"
          )
  </template>
  <script>
  import { mapState, mapActions } from "vuex";
  import { cadastroViagemDB } from "@/helpers/dexieDb";
  import viagensService from "@/services/viagens.service";
  import dayjs from "dayjs";
  import GlobalStore from "@/store/modules/global";
  import { getLocation } from "@/util/geolocation";
  import { throwError } from "rxjs";
  import { StatusViagem } from "@/models/status-viagem.enum";
  import { SentidoViagem } from "@/models/sentido-viagem.enum";
  export default {
    name: "TravelPending",
    // props: { itensNotSincronized: { type: Boolean, default: true } },
    data: () => ({
      sincronized: {
        total: 10,
        itens: [],
        loading: false,
      },
      dialog: false,
      itensNotSincronized: false,
      location: {},
    }),
    computed: {
      ...mapState("viagens", ["hasTravelActive"]),
      ...mapState("viagens", ["startVerification"]),
      ...mapState("viagens", ["table"]),
      ...mapState("viagens", ["updateTable"]),
    },
    watch: {
      startVerification: function () {
        this.verificationCache();
      },
      hasTravelActive: function () {
        this.verifyIndexDBList();
      },
      updateTable: function () {
        this.verificationCache();
      },
    },
    mounted() {
      this.verificationCache();
      this.verifyIndexDBList();
      this.showPosition();
    },
    methods: {
      ...mapActions("viagens", { verificationCache: "VERIFY_INDEXDB" }),
      ...mapActions("viagens", { verifyLocation: "VERIFY_GEOLOCATION" }),
      ...mapActions("viagens", {
        synchronizeTraveInitial: "SYNCHRONIZE_TRAVEL_INITIAL",
      }),
      ...mapActions("viagens", {
        synchronizeTravelFinish: "SYNCHRONIZE_TRAVEL_FINISH",
      }),
      ...mapActions("viagens", {
        synchronizeTraveInitialBack: "SYNCHRONIZE_TRAVEL_INITIAL_BACK",
      }),
      ...mapActions("viagens", {
        saveTravelInitial: "SAVE_TRAVEL_INITIAL",
      }),
  
      async send(item) {
        let viagem = await cadastroViagemDB.cadastroViagem.toArray();
  
        // viagem.forEach((t) => {
        if (item.status === StatusViagem.INICIADA) {
          this.synchronizeTraveInitial();
        }
        if (item.status === StatusViagem.FINALIZADA) {
          this.synchronizeTravelFinish(this.location);
        }
        if (
          item.status === StatusViagem.INICIADA &&
          item.sentido === SentidoViagem.VOLTA
        ) {
          this.synchronizeTraveInitialBack();
        }
        /// TEMPORARIO
        if (
          item.status === undefined &&
          item.sentido === undefined
        ) {
          viagensService.create(item).subscribe(
          (res) => {
            GlobalStore.setSnackBar({
              show: true,
              message: "Viagem cadastrada com sucesso!",
              type: "success",
            });
            cadastroViagemDB.cadastroViagem
                .delete(item.idCache)
            this.verificationCache();
  
          },
          (error) => {
            throwError(error);
          });
        }
        // });
      },
      verifyIndexDBList() {
        this.table.viagens.itens.forEach((viagem) => {
          const verifyDuplicad = this.table.notSincronized.viagens.itens.filter(
            (e) => {
              return (
                e.dataInicio === viagem.dataInicio &&
                e.status === StatusViagem.INICIADA &&
                e.sentido === SentidoViagem.IDA
              );
            }
          );
          if (verifyDuplicad.length > 0) {
            this.deleteViagemById(verifyDuplicad[0].idCache);
          }
        });
      },
      activeDialog(idCache) {
        this.idCacheIndexDB = idCache;
        this.dialog = true;
      },
      deleteViagemById(idCache) {
        cadastroViagemDB.cadastroViagem
          .delete(this.idCacheIndexDB || idCache)
          .then((res) => {
            this.dialog = false;
            this.verificationCache();
          });
      },
      showPosition() {
        getLocation().subscribe(
          (res) => {
            this.location.latitude = res.latitude;
            this.location.longitude = res.longitude;
            this.verifyLocation(false);
          },
          (error) => {
            this.verifyLocation(true);
            GlobalStore.setSnackBar({
              show: true,
              message: "Ative sua localização",
              type: "error",
            });
          }
        );
      },
      finishTravelIndexDB(idCache) {
        cadastroViagemDB.cadastroViagem.get(idCache).then((res) => {
          res.dataFim = this.dateToday();
          res.status = StatusViagem.FINALIZADA;
          cadastroViagemDB.cadastroViagem.put(res).then((result) => {
            this.verificationCache();
          });
        });
      },
      dateFormat(date) {
        return dayjs(date).format("DD/MM/YYYY HH:mm:ss");
      },
      dateToday() {
        var dataHoraAtual = new Date();
        dataHoraAtual.setUTCHours(dataHoraAtual.getUTCHours());
        return dayjs(dataHoraAtual.toISOString()).format("YYYY-MM-DDTHH:mm:ss");
      }
    },
  };
  </script>
  